import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-allocated-projects-list',
  templateUrl: './allocated-projects-list.component.html',
  styleUrls: ['./allocated-projects-list.component.css']
})
export class AllocatedProjectsListComponent implements OnInit {
  loading = true;
  projects: any[] = [];

  constructor(
    private apiService: ApiService,
    private toastr: ToastrMsgService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.apiService.getProjectsAwardedToMe().subscribe({
      next: (res: any) => {
        this.loading = false;
        this.projects = res?.data || [];
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err.error?.message || 'Failed to load allocated projects');
      }
    });
  }

  formatCurrency(amount: number | string): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
    }).format(Number(amount) || 0);
  }

  formatDate(dateString: string): string {
    if (!dateString) {
      return '—';
    }
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  viewAllocatedWbs(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/work-breakdown-structure', projectId], {
      queryParams: { bidderView: 'true' }
    });
  }

  viewProject(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/view-project', projectId]);
  }

  viewStaff(project: any): void {
    this.viewProject(project);
  }

  viewMachines(project: any): void {
    this.viewProject(project);
  }

  viewGis(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/gis-project', projectId]);
  }

  viewWorkLog(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/add-work-project', projectId]);
  }

  viewDocuments(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/document-list', projectId]);
  }

  viewDailyReports(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/labour-mobilization/daily-reports/add'], {
      queryParams: { project_id: projectId }
    });
  }

  viewProgress(project: any): void {
    const projectId = project?.project_id;
    if (!projectId) {
      this.toastr.error('Invalid project');
      return;
    }
    this.router.navigate(['/home/add-progress-report'], {
      queryParams: { project_id: projectId }
    });
  }
}
